import { render, staticRenderFns } from "./AirQualityPage.vue?vue&type=template&id=01154ad2"
import script from "./AirQualityPage.vue?vue&type=script&lang=js"
export * from "./AirQualityPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports